import { Seller } from '@fiverr-private/header/';

export default Seller;
